/**
 * @type enum
 */
export enum Orientation {
	LANDSCAPE = 'landscape',
	LANDSCAPE_PHONE = 'landscapePhone',
	PORTRAIT = 'portrait',
	PORTRAIT_PHONE = 'portraitPhone',
}
